'use strict';

/*=============================================
 * Table of content - Longreads: Common
-----------------------------------------------
    1. Faq
    2. Anchor animate
    4. Active header local
    5. Active menu header local
==============================================*/

// ================
// 1. Faq
// ================

var faqItem = $(".faq__item");

faqItem.each(function (i, item) {
    item.onclick = function (e) {
        $(this).toggleClass('is-active');
        $(this).find('.faq__answer').slideToggle();
    };
});

// ====================
// 2. Anchor animate
// ====================

$('main a[href^="#"]').on('click', function (e) {
    var elementClick = $(this).attr('href');
    var destination = $(elementClick).offset().top - 100;

    $('html:not(:animated),body:not(:animated)').animate({
        scrollTop: destination
    }, 800);
});

// ========================
// 4. Active header local
// ========================

var headerLocal = $('.header-local');

if (headerLocal.length) {
    document.addEventListener('scroll', function () {

        if (!headerLocal[0].getBoundingClientRect().top) headerLocal.addClass('is-sticky');else headerLocal.removeClass('is-sticky');
    });
}


// ===============================
// 5. Active menu header local
// ===============================

if (headerLocal.length) {
    var headerLocalBurger = $('.header-local__burger');
    var headerLocalNav = $('.header-local__nav');
    var headerLocalNavDropdown = $('.header-local__nav .is-dropdown');
    var headerLocalNavDropdownItem = $('.header-local__nav .is-dropdown span');

    headerLocalBurger.on('click', function () {
        headerLocalBurger.toggleClass('is-show');
        headerLocalNav.slideToggle();
    });

    headerLocalNavDropdownItem.on('click', function () {
        headerLocalNavDropdown.toggleClass('is-show');
        $(this).parent().find('ul').slideToggle();
    });
}
